













import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputTextarea'
})
export default class InputTextarea extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate
}
